<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <label>{{ $t('page.generic.code') }} <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" id="code" v-model="codingSchema.code" aria-required="true"
                              :required=true disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label>{{ $t('page.generic.version') }} <required-field /></label>
                <b-form-input aria-describedby="codingSchemaVersionField" :state="errors.some((e) => e.field === 'codingSchemaVersion')?false:null"
                              type="text" id="version" v-model="codingSchema.codingSchemaVersion" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>{{ $t('page.generic.name') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="codingSchema.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="description" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="codingSchema.description"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12" v-if="codingSchema.documentTypes && codingSchema.documentTypes.length">
              <label>Document Type associati</label>
              <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
                       :small="small"
                       :fixed="fixed"
                       :sort-by="sortBy"
                       responsive="sm" :items="codingSchema.documentTypes" :fields="captions"
                       :current-page="currentPage"
                       :per-page="perPage">
                <template slot="actions" slot-scope="data">
                  <div class="btn-group" role="group">
                    <button class="btn btn-danger fa fa-trash" @click="removeDocumentType(data.item.id)"></button>
                  </div>
                </template>
              </b-table>
              <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                              next-text="Next" hide-goto-end-buttons/>
              </nav>

            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right ml-3" type="button" @click="beforeSave">
                {{ $t('actions.save') }}
              </button>
              <!--<button class="btn btn-warning float-right ml-3" @click="fetchData">
                {{ $t('actions.reset') }}
              </button>-->
              <router-link class="btn btn-primary float-right ml-3" role="button"
                           :to="{name: 'documentTypeCodingSchemaRoute'}">
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- Modal Component -->
    <b-modal title="Modifica Coding Schema" class="modal-danger" v-model="deleteModal"
             @ok="updateCodingSchema"
             ok-variant="danger">
      L'aggiornamento del coding schema porterà all'eliminazione di {{deletedDocumentsType}} Document Type collegati
    </b-modal>

  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '@/components/PageTitle'
  import CodingSchemaService from "@/services/CodingSchemaService"
  import i18n from '@/config/i18n'
  import RequiredField from "../../components/RequiredField";

  const codingSchemaService = CodingSchemaService.build();

  export default {
    name: 'codingSchemaEdit',
    inheritAttrs: false,
    components: {
      RequiredField,
      PageTitle
    },
    props: {
      id: {
        required: true
      },
      sortBy:{
        type: String,
        default: 'code'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      fields: {
        type: [Array, Object],
        default: () => [
          {key: 'code', label: i18n.t('page.generic.code'), sortable: true, sortDirection: 'desc'},
          {key: 'label', label: i18n.t('page.generic.name'), sortable: true},
          {key: 'description', label: i18n.t('page.generic.description'), sortable: true},
          {key: 'actions', label: '', sortable: false},
        ]
      },
      perPage: {
        type: Number,
        default: 10
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      totalRows: function () {
        return this.getRowCount()
      },
      captions: function () {
        return this.fields
      }
    },
    data() {
      return {
        codingSchema: {},
        errors: [],
        currentPage: 1,
        deleteModal: false,
        deletedDocumentsType: 0
      }
    },
    created() {
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData()
    },
    methods: {
      getRowCount: function () {
        return this.codingSchema.documentTypes ? this.codingSchema.documentTypes.length : 0
      },
      async fetchData() {
        try {
          this.deletedDocumentsType = 0;
          this.codingSchema = await codingSchemaService.read(this.id)
        } catch (exception) {
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }
      },
      beforeSave() {
        if (this.deletedDocumentsType > 0) {
          this.deleteModal = true
        } else {
          this.updateCodingSchema()
        }
      },
      async updateCodingSchema() {
        try {
          await codingSchemaService.update(this.codingSchema);
          this.$router.push({name: 'documentTypeCodingSchemaShowRoute', params: {id: this.id}});
          miniToastr.info("Coding Schema aggiornato con successo");
        } catch (exception) {
          if(exception.errors){
            this.errors = exception.errors;
            exception.errors.forEach(function (element) {
              miniToastr.error(element.message);
            });
          } else {
            miniToastr.error(exception.message);
          }
        }

      },
      removeDocumentType(id) {
        this.codingSchema.documentTypes = this.codingSchema.documentTypes.filter(e => e.id !== id);
        this.deletedDocumentsType++
      }
    }
  }
</script>

